import { valibotResolver } from '@hookform/resolvers/valibot';
import { nonEmpty, nonNullable, nullable, number, object, pipe, string } from 'valibot';

export const CREATE_LOCATION_FIELDS = {
  NAME: 'name',
  PARENT_ID: 'parent_id',
};

export const schemaCreateLocation = valibotResolver(
  object({
    [CREATE_LOCATION_FIELDS.NAME]: pipe(string(), nonEmpty('This field is required.')),
    [CREATE_LOCATION_FIELDS.PARENT_ID]: pipe(
      nonNullable(nullable(number()), 'This field is required.'),
      nonEmpty('This field is required.'),
    ),
  }),
);

export const createLocationDefaultValue = {
  [CREATE_LOCATION_FIELDS.NAME]: '',
  [CREATE_LOCATION_FIELDS.PARENT_ID]: null,
};
